// 通用
export default {
  com_hi: '你好',
  com_welcome: '欢迎使用',
  // 操作类型
  com_operationTypes: [
    {
      name: '新建',
      value: 0,
    },
    {
      name: '编辑',
      value: 1,
    },
    {
      name: '删除',
      value: 2,
    },
    {
      name: '禁用',
      value: 3,
    },
    {
      name: '启用',
      value: 4,
    },
    // 未知
    {
      name: '--',
      value: 9,
    },
  ],

  // header
  com_header_title: '运维管理系统',
  com_header_help: '帮助文档',
  com_header_account: '账号信息',
  com_header_logout: '退出登录',
  com_header_document: '文档',
  com_header_setting: '系统管理',
  com_header_message: '消息',
  com_header_logout_confirm_text: '确定退出登录? ',
  com_header_logout_timeout: '登录已超时',
  com_header_station: '站点',
  com_header_device: '设备',
  com_header_docs: '文档',
  com_header_search_result1: '搜索 ',
  com_header_search_result2: ',共',
  com_header_search_result3: '个结果',
  com_header_search_placeholder: '请输入站点/设备/文档关键字',

  // 菜单
  com_sider_menu_welcome: '欢迎页面',
  com_sider_menu_home: '首页',
  // site
  com_sider_menu_site: '站点',
  com_sider_menu_site_add: '添加新站点',
  com_sider_menu_site_edit: '编辑站点',
  com_sider_menu_site_detail: '站点详情',
  // device
  com_sider_menu_device: '设备',
  com_sider_menu_device_list: '设备列表',
  com_sider_menu_device_add: '添加新设备',
  com_sider_menu_device_edit: '编辑设备',
  com_sider_menu_device_detail: '设备详情',
  com_sider_menu_device_terminal: '设备终端',
  // issue
  com_sider_menu_issue: '问题',
  com_sider_menu_issue_list: '问题列表',
  com_sider_menu_issue_add: '添加新问题',
  com_sider_menu_issue_edit: '编辑问题',
  com_sider_menu_issue_add_anonymous: '添加匿名问题',
  com_sider_menu_issue_detail: '问题详情',

  com_sider_menu_system: '系统',
  com_sider_menu_system_welcome: '欢迎页面',
  com_sider_menu_system_dashboard: '系统面板',
  com_sider_menu_and_interface: '菜单和接口',
  // customer
  com_sider_menu_customer: '客户管理',
  com_sider_menu_customer_add: '添加新客户',
  com_sider_menu_customer_edit: '编辑客户',
  com_sider_menu_customer_detail: '客户详情',
  // user
  com_sider_menu_user: '用户管理',
  com_sider_menu_user_add: '添加新用户',
  com_sider_menu_user_edit: '编辑用户',
  com_sider_menu_user_auth: '用户授权',
  com_sider_menu_user_detail: '用户详情',
  // role
  com_sider_menu_role: '角色管理',
  com_sider_menu_role_add: '添加新角色',
  com_sider_menu_role_edit: '编辑角色',
  com_sider_menu_role_auth_menu: '菜单功能授权',
  com_sider_menu_role_auth_data: '数据授权',

  com_sider_menu_model: '设备模型',
  com_sider_menu_model_alias: '设备模型别名',
  // config model
  com_sider_menu_config: '数据模型',
  com_sider_menu_config_list: '数据模型列表',
  com_sider_menu_config_add: '添加新数据模型',
  com_sider_menu_config_edit: '编辑数据模型',
  com_sider_menu_config_group: '数据模型分组管理',
  // docs
  com_sider_menu_docs: '帮助文档',
  com_sider_menu_docs_list: '帮助文档列表',
  com_sider_menu_docs_search: '帮助文档搜索',
  com_sider_menu_docs_add: '添加文档',
  com_sider_menu_docs_edit: '编辑文档',
  // logs
  com_sider_menu_logs: '日志管理',
  com_sider_menu_logs_action: '操作日志',
  com_sider_menu_logs_protocol: '协议日志',
  com_sider_menu_logs_error: '错误日志',

  com_sider_menu_no_auth: '没有权限',
  com_sider_menu_my: '我的信息',
  com_sider_menu_black: '设备黑名单',

  // 分页
  com_pagination_total: '总条数',

  // 报错提示
  com_error_network: '网络异常',
  com_error_network_description: '当前网络异常，请稍后再试',
  com_error_404: '404 Not Found',
  com_error_404_descriptoin: '抱歉，您访问的页面不存在',
  com_error_forbidden: '403 Forbidden',
  com_error_forbidden_description: '抱歉，您无权限访问此页面，企业微信联系创建者',
  com_error_500: '系统错误，请稍候再试',
  com_error_net: '网络繁忙，请稍候再试',
  com_api_error_404: '接口不存在',

  // 提示
  com_msg_empty: '没有数据',
  com_msg_connect_pending: '连接中...',
  com_msg_connect: '连接',
  com_msg_success: '成功',
  com_msg_fail: '失败',
  com_msg_timeout: '超时',
  com_msg_add_success: '添加成功',
  com_msg_add_fail: '添加失败',
  com_msg_edit_success: '编辑成功',
  com_msg_edit_fail: '编辑失败',
  com_msg_delete_success: '删除成功',
  com_msg_delete_fail: '删除失败',
  com_msg_maintenance_success: '维护成功',
  com_msg_maintenance_fail: '维护失败',
  com_msg_save_success: '保存成功',
  com_msg_save_fail: '保存失败',
  com_msg_copy_success: '复制成功',
  com_msg_copy_fail: '复制失败',
  com_msg_disabled_success: '禁用成功',
  com_msg_disabled_fail: '禁用失败',
  com_msg_enabled_success: '启用成功',
  com_msg_refresh_success: '刷新成功',
  com_msg_refresh_fail: '刷新失败',
  com_msg_close_success: '关闭成功',
  com_msg_reopen_success: '重新打开成功',
  com_msg_fork_success: '派生成功',
  com_msg_data_auth_success: '数据授权成功',
  com_msg_select_item_first: '请先选择数据',
  com_msg_select_group_first: '请先选择分组',
  com_msg_select_params_first: '请先选择参数',
  com_msg_not_be_empty: '值不能为空',
  com_msg_not_ok: '值不正确或格式错误',
  com_msg_selected: '已选择',
  com_msg_error: '错误',
  com_msg_result: '结果',

  // network error
  com_network_error: 'Sorry, 网络繁忙!',
  com_network_please: '请稍候',
  com_network_retry: '重试',
  com_network_later: '',

  // no auth
  com_no_auth_tip1: '你没有权限访问',
  com_no_auth_tip2: '如果需要，请联系管理员!',

  // 按钮
  com_btn_reload: '重新加载',
  com_btn_return_home: '返回首页',
  com_btn_login: '登录',
  com_btn_edit: '编辑',
  com_btn_edit_content: '编辑内容',
  com_btn_edit_prop: '编辑属性',
  com_btn_add: '添加',
  com_btn_add_device: '添加设备',
  com_btn_fork: '派生',
  com_btn_delete: '删除',
  com_btn_delete_batch: '批量删除',
  com_btn_back: '返回',
  com_btn_cancel: '取消',
  com_btn_cancel_edit: '取消编辑',
  com_btn_enabled: '启用',
  com_btn_disabled: '禁用',
  com_btn_reset: '重置',
  com_btn_search: '搜索',
  com_btn_search_folder: '搜索当前目录',
  com_btn_search_global: '全局搜索',
  com_btn_iknown: '知道了',
  com_btn_more: '更多',
  com_btn_lock: '锁定',
  com_btn_unlock: '解锁',
  com_btn_detail: '详情',
  com_btn_submit: '提交',
  com_btn_connect: '连接',
  com_btn_disconnect: '断开',
  com_btn_refresh: '刷新',
  com_btn_excute: '执行',
  com_btn_finish: '完成',
  com_btn_confirm: '确定',
  com_btn_remove: '移除',
  com_btn_save: '保存',
  com_btn_create: '创建',
  com_btn_close: '关闭',
  com_btn_download: '下载',
  com_btn_share: '分享',
  com_btn_set: '设置',
  com_btn_copy: '复制',
  com_btn_auth: '授权',
  com_btn_webui: 'WEBUI',
  com_btn_ssh: 'SSH',
  com_btn_close_vpn: '关闭VPN',
  com_btn_other: '其他',
  com_btn_other_control: '其他控制',
  com_btn_export: '导出',
  com_btn_import: '导入',
  com_btn_import_value: '导入值',
  com_btn_comment: '评论',
  com_btn_comment_and_close: '评论并关闭问题',
  com_btn_user_add: '添加新用户',
  com_btn_user_manage: '管理用户',
  com_btn_customer_manage: '管理客户',
  com_btn_device_model_manage: '管理设备模型',
  com_btn_lookfor: '查询',
  com_btn_disabled2: '禁用',
  com_btn_enabled2: '启用',
  com_btn_expand: '展开',
  com_btn_collapse: '收起',
  com_btn_new: '新建',
  com_btn_update: '更新',
  com_btn_upload_image: '上传图片',
  com_btn_insert_image: '上传并插入图片',
  com_btn_insert_image_btn: '插入图片',
  com_btn_insert_video: '上传并插入视频',
  com_btn_upload_video: '上传视频',
  com_btn_get_share_file: '获取文件',
  com_btn_destroy: '销毁',
  com_btn_logout: '退出',

  // 过程
  com_ongoing_delete: '删除中...',
  com_ongoing_enable: '启用中...',
  com_ongoing_disable: '禁用中...',
  com_ongoing_save: '保存中...',
  com_ongoing_update: '更新中...',
  com_ongoing_close_vpn: '关闭VPN中...',
  com_ongoing_remove: '移除中...',
  com_ongoing_refresh: '刷新中...',

  // 表格
  com_table_index: '序号',
  com_table_id: 'ID',
  com_table_time: '时间',
  com_table_created: '创建',
  com_table_created_time: '创建时间',
  com_table_created_by: '创建',
  com_table_updated: '更新',
  com_table_updated_time: '更新时间',
  com_table_status: '状态',
  com_table_user_created: '创建用户',
  com_table_operation: '操作',
  com_table_no_data: '没有数据',
  com_table_loading: '加载中...',
  com_table_name: '名称',
  com_table_code: '编号',
  com_table_parent_model: '父模型',
  com_table_yes: '是',
  com_table_no: '否',
  com_table_disabled: '禁用',
  com_table_contact: '联系',
  com_table_address: '地址',
  com_table_telephone: '电话',
  com_table_type: '类型',
  com_table_device_name: '设备名称',
  com_table_falut_time: '故障总时长',
  com_table_fault_count: '故障次数',
  com_table_action: '操作',
  com_table_souce: '来源',
  com_table_warning_level: '告警等级',
  com_table_data: '数据',
  com_table_check_all: '全选',
  com_table_check_reverse: '反选',
  com_table_alarm_name: '告警名称',

  // 表单
  com_form_all: '所有',
  com_form_area: '区域',
  com_form_area_all: '所有区域',
  com_form_area_select: '请选择区域',
  com_form_area_region_label: '区域 / 地区(国家)',
  com_form_region: '地区(国家)',
  com_form_region_all: '所有地区(国家)',
  com_form_region_select: '请选择地区(国家)',
  com_form_region_area_label: '所属区域 / 国家',
  com_form_upload_image_error: '请上传图片',
  com_video_not_support: '您的浏览器不支持 HTML5 视频，请升级或更换浏览器。',

  com_form_name: '名称',
  com_form_keyword_input: '请输入搜索关键字',
  com_form_enabled: '启用',
  com_form_enabled_label: '是否启用',
  com_form_enabled_success: '启用成功',
  com_form_enabled_fail: '启用失败',
  com_form_disabled: '禁用',
  com_form_status_all: '所有状态',
  com_form_input_placeholder: '请输入',
  com_form_select_placeholder: '请选择',
  com_form_description: '描述',
  com_form_description_placeholder: '请输入描述',
  com_form_remark: '备注',
  com_form_remark_placeholder: '请输入备注',
  com_form_attachment: '附件',
  com_form_attachment_download: '下载附件',
  com_form_order_field: '排序字段',
  com_form_order_desc: '倒序',
  com_form_order_esc: '正序',
  com_form_password_help: '8-32位，必须包含大小字母、数字和特殊字符',
  com_form_url: 'URL',
  com_form_name_placeholder: '请输入名称',
  com_form_fault_code_placeholder: '请输入故障代码',
  com_form_warning_name_placeholder: '请输入告警名称',
  com_form_device_name_placeholder: '请输入设备名称',
  com_form_device_param_name_placeholder: '请输入搜索关键词，如参数',
  com_form_device_ctrl_placeholder: '请输入搜索关键词，如控制参数',
  com_form_device_operation_placeholder: '请输入搜索关键词，如数据',
  com_form_device_param_event_placeholder: '请输入搜索关键字，如设备名称/数据/用户',
  com_form_device_fault_placeholder: '请输入搜索关键字，如设备/告警名称',

  // 表单验证
  // 整型
  com_form_type_integer: '整数',
  com_form_validate_type_integer: '仅限整数',
  com_form_validate_type_integer_min_max: '仅限整数，最小:{min}，最大:{max}',
  com_form_validate_type_integer_range_help:
    '格式为：0~100，0是最小值，100是最大值。例如-10~10、-10~-5、0~10等。不填写表示没有范围。',
  com_form_validate_type_integer_range_error1: '格式不正确，正确如：0~100',
  com_form_validate_type_integer_range_error2: '格式不正确，~符号之前的值必须小于后面的值。',
  // 浮点型
  com_form_type_float: '浮点数',
  com_form_validate_type_float: '仅限浮点数',
  com_form_validate_type_float_min_max: '仅限浮点数，最小:{min}，最大:{max}，小数:{decimal}',
  com_form_validate_type_float_range_help:
    '格式为：0~100|2，0为最小值，100为最大值，2为保留小数点，最大小数点为99。不填写表示没有范围。',
  com_form_validate_type_float_range_error1: '格式不正确，正确的如：0~100|22，小数位数最大为99。',
  com_form_validate_type_float_range_error2: '格式不正确，~符号之前的值必须小于后面的值。',
  // 字符串型
  com_form_type_string: '字符型',
  com_form_validate_type_string: '仅限字符型',
  com_form_validate_type_string_min_max: '仅限字符型，最小长度：{min}，最大长度：{max}',
  com_form_validate_type_string_help:
    '格式为：0~100，0是最小输入长度，100是最大输入长度。不填写表示没有范围',
  com_form_validate_type_string_error1: '格式不正确，正确如：0~100，仅数字，由~符号隔开',
  com_form_validate_type_string_error2: '格式不正确，~符号之前的值必须小于后面的值。',
  // 枚举型
  com_form_type_enumeration: '枚举型',
  com_form_type_enumeration_help:
    '格式为：“test|1|number”，“test”为显示值，“1”为值，“number”为类型（未填写时默认类型为String，仅支持三种类型：数字、字符串和布尔值），多条数据则换行输入',
  com_form_type_enumeration_error1: '行{index}的格式不正确，例如：abc|123不能包含多个竖线',
  com_form_type_enumeration_error2: '行{index}的格式不正确，例如：Type仅支持数字、字符串、布尔值',

  com_form_contact: '联系方式',
  com_form_contact_placeholder: '请输入联系方式',
  com_form_contact_person: '联系人',
  com_form_contact_person_placeholder: '请输入联系人',
  com_form_telephone: '联系电话',
  com_form_telephone_placeholder: '请输入联系电话',
  com_form_address: '地址',
  com_form_address_placeholder: '请输入地址',

  // 上传
  com_upload_tip1: '单击或拖动文件到此区域进行上载',
  com_upload_only_text: '只有',
  com_upload_tip3: ' 不超过',
  com_upload_size_error: '文件大小不能超过{maxSize}',
  com_upload_type_error: '只有 {typeList} 可以上传',
  com_upload_btn: '上传',
  com_upload_image: '点击选择需要上传的图片',
  com_upload_json_tip: '只能上传JSON，不能超过5M。',
  com_upload_support_type: '支持',
  com_upload_tip: '只能上传：',
  com_upload_tip_video: '单击或拖动视频文件到此区域进行上载',
  com_upload_select_file: '选择一个文件',
  com_upload_filename_error: '文件名必须为: {filename},当前文件名为: {currentFilename}',

  // IP地点
  com_location_default: '中国|广东|深圳市，N/A',

  // 时间
  com_time_day: '天',
  com_time_week: '周',
  com_time_month: '月',
  com_time_year: '年',
  com_time_custom: '自定义',
  com_time_hour: '小时',
  com_time_min: '分',
  com_time_minute: '分',
  com_time_second: '秒',

  com_time_d: '天',
  com_time_h: '时',
  com_time_m: '分',
  com_time_s: '秒',

  // 故障
  com_fault_all: '全部',
  com_fault_ma: 'MA',
  com_fault_ca: 'CA',
  com_fault_oa: 'OA',
  // 故障类型
  com_fault_type: '故障类型',
  com_alarm_type: '告警类型',
  com_fault_type_offline: '离线',
  com_fault_type_alarm: '告警',
  com_fault_type_fault: '故障',
  com_fault_type_unavailable: '不可用',
  com_fault_current: '当前告警',
  com_fault_history: '历史告警',
};
